import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

// Import Component
import { JubiliComponent } from "./jubili.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { pageRoute } from "../../constant/pageRoute";
import { CompanyManageComponent } from "./company/company-manage.component";
import { UserManageComponent } from "./usermanage/user-manage.component";
import { QuotationItemComponent } from "./quotation/quotation-item.component";
import { SettingComponent } from "./setting/setting.component";
import { AuthGuard } from "../../service/components/authentication/guards/auth.guard";
import { AuthGuardJubili } from "../../service/components/authentication/guards/auth.guard.jubili";
import {UploadImageImportItemComponent} from "./upload-image-imaport-item/upload-image-import-item.component";
import {ImageUploadComponent} from "./upload-image-imaport-item/image-upload/image-upload.component";
import { CompanySettingFormComponent } from "./company/company-setting-form/company-setting-form.component";

const detailsRoutes: Routes = [
    {
        path: pageRoute.jubili,
        component: JubiliComponent,
        // canActivate: [AuthGuard],
        children: [
            {
                path: "",
                component: JubiliComponent,
                // canActivate: [AuthGuard, AuthGuardJubili]
            },
            {
                path: pageRoute.jubDashboard,
                component: DashboardComponent,
                canActivate: [AuthGuard, AuthGuardJubili]
            },
            {
                path: pageRoute.jubCompany,
                component: CompanyManageComponent,
                canActivate: [AuthGuard, AuthGuardJubili]
            },
            {
                path: pageRoute.jubUserlist,
                component: UserManageComponent,
                canActivate: [AuthGuard, AuthGuardJubili]
            },
            //{
            //    path: pageRoute.jubQolist,
            //    component: QuotationItemComponent,
            //    canActivate: [AuthGuard, AuthGuardJubili]
            //},
            {
                path: pageRoute.jubSetting,
                component: SettingComponent,
                canActivate: [AuthGuard, AuthGuardJubili]
            },
            {
              path: pageRoute.jubUploadImage,
              component: UploadImageImportItemComponent,
              canActivate: [AuthGuard, AuthGuardJubili]
            },
          {
            path: pageRoute.jubUploadImageItem,
            component: ImageUploadComponent,
            canActivate: [AuthGuard, AuthGuardJubili]
          },
          {
            path: pageRoute.jubWebhook,
            loadChildren: './webhook/webhook.module#WebhookModule'
            //'../feature/path/sample-tage.module#SameTagModule'
          },
          {
            path: pageRoute.jubSettingForm,
            component: CompanySettingFormComponent,
            canActivate: [AuthGuard, AuthGuardJubili]
          }
        ]
    }
];
@NgModule({
    imports: [
        RouterModule.forChild(detailsRoutes)
    ],
    exports: [
        RouterModule
    ]
})

export class JubiliRoutingModule { }
